import { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import AreasSection from "@/components/AreasSection";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";
import Footer from "@/components/Footer";
import HeroSection from "@/components/HeroSection";
import ManifestoSection from "@/components/ManifestoSection";
import Marquee from "@/components/Marquee";
import PrinciplesSection from "@/components/PrinciplesSection";
import QuoteModal from "@/components/QuoteModal";
import ServicesSection from "@/components/ServicesSection";
import SiteHeader from "@/components/SiteHeader";
import TestimonialsSection from "@/components/TestimonialsSection";
import "@/App.css";

function Home() {
  const [quoteOpen, setQuoteOpen] = useState(false);
  const [selectedService, setSelectedService] = useState("");
  const openQuote = (service = "") => { setSelectedService(service); setQuoteOpen(true); };
  const closeQuote = () => { setQuoteOpen(false); setSelectedService(""); };

  return <div className="site-shell">
    <SiteHeader onQuote={openQuote} />
    <main>
      <HeroSection onQuote={openQuote} />
      <Marquee />
      <PrinciplesSection />
      <ServicesSection onQuote={openQuote} />
      <ManifestoSection />
      <TestimonialsSection />
      <AreasSection onQuote={openQuote} />
      <Footer onQuote={openQuote} />
    </main>
    <FloatingWhatsApp />
    <QuoteModal open={quoteOpen} onClose={closeQuote} initialService={selectedService} />
  </div>;
}

export default function App() {
  return <BrowserRouter><Routes><Route path="*" element={<Home />} /></Routes></BrowserRouter>;
}
